import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { Link, Stack, Tooltip } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { useBikeleasingPortalLinkBuilder } from 'probonio-shared-ui/utils/bikeleasingUrl';
import { Trans, useTranslation } from 'react-i18next';
import { BenefitPaper } from '../../component/benefitTabs/BenefitPaper';
import { ExternalLinkButton } from '../../component/button/ExternalLinkButton';
import { BIKELEASING_INSURANCE_PLAN_URL } from '../../constants';
import { getBenefitIcon } from '../../module/benefits/BenefitIcon';
import BenefitSubPage from '../../module/benefits/BenefitSubPage';
import { useBikeleasingPrecondition } from '../../module/benefits/bikeleasingV2/useBikeleasingPrecondition';
import { AuthorizedLayout } from '../../module/navigation/AuthorizedLayout';

const BikeleasingInsurancePage: React.FC = () => {
  const { t } = useTranslation('extensions');
  const { PreconditionComponent, isPreconditionMet } = useBikeleasingPrecondition();
  const benefit = BenefitDTOBenefitEnum.BikeleasingV2;
  const buildBikeleasingPortalLink = useBikeleasingPortalLinkBuilder();
  const bikeleasingReportDamageUrl = buildBikeleasingPortalLink(`/user/report-damage`);
  const bikeleasingInsuranceCasesOpenUrl = buildBikeleasingPortalLink(`/user/employer/insurances/open`);
  const bikeleasingInsuranceCasesClosedUrl = buildBikeleasingPortalLink(`/user/employer/insurances/closed`);

  return (
    <AuthorizedLayout
      title={t('bikeleasing_v2.insurance.title')}
      breadcrumbs={[{ title: t(`benefitsModule:${benefit}.title`), to: `/benefits/${benefit.toLowerCase()}` }]}
    >
      <BenefitSubPage
        icon={getBenefitIcon(BenefitDTOBenefitEnum.BikeleasingV2)}
        title={t('bikeleasing_v2.title')}
        subTitle={t('bikeleasing_v2.insurance.title')}
        menu={
          isPreconditionMet && (
            <ExternalLinkButton href={bikeleasingReportDamageUrl} variant="contained">
              {t('bikeleasing_v2.insurance.reportInsuranceClaim')}
            </ExternalLinkButton>
          )
        }
        infoContent={
          <Tooltip title={t('bikeleasing_v2.insurance.infoTooltip')}>
            <Link href={BIKELEASING_INSURANCE_PLAN_URL} sx={{ ml: 0.5 }} rel="noopener noreferrer" target="_blank" color="text.secondary">
              <InfoOutlineIcon sx={{ verticalAlign: 'middle' }} />
            </Link>
          </Tooltip>
        }
      >
        {isPreconditionMet ? (
          <BenefitPaper>
            <Trans i18nKey="extensions:bikeleasing_v2.insurance.pageText" />
            <Stack spacing={1} sx={{ mt: 3 }}>
              <ExternalLinkButton href={bikeleasingInsuranceCasesOpenUrl} sx={{ justifyContent: 'flex-start', width: 'fit-content' }}>
                {t('bikeleasing_v2.insurance.viewAllOpenCases')}
              </ExternalLinkButton>

              <ExternalLinkButton href={bikeleasingInsuranceCasesClosedUrl} sx={{ justifyContent: 'flex-start', width: 'fit-content' }}>
                {t('bikeleasing_v2.insurance.viewAllClosedCases')}
              </ExternalLinkButton>
            </Stack>
          </BenefitPaper>
        ) : (
          <BenefitPaper>{PreconditionComponent}</BenefitPaper>
        )}
      </BenefitSubPage>
    </AuthorizedLayout>
  );
};

export default BikeleasingInsurancePage;
